export const iconFontAwesomeSportsFitnessBicycle = (
	<i className="fa-solid fa-bicycle"></i>
);
